import { render } from "./CalendarView.vue?vue&type=template&id=9884dc10&ts=true"
import script from "./CalendarView.vue?vue&type=script&lang=ts"
export * from "./CalendarView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/View/CalendarView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9884dc10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9884dc10', __exports__)) {
    api.reload('9884dc10', __exports__)
  }
  
  module.hot.accept("./CalendarView.vue?vue&type=template&id=9884dc10&ts=true", () => {
    api.rerender('9884dc10', render)
  })

}


export default __exports__